/* eslint sort-keys: "error" */
export default {
  de: {
    business: {
      features: ['Alle Funktionen', 'Unbegrenzt viele Nutzer'],
      title: 'Business'
    },
    business_earlybird: {
      features: ['Alle Funktionen', 'Unbegrenzt viele Nutzer'],
      title: 'Team Power'
    },
    freelancer: {
      features: ['Alle Funktionen', '1 Nutzer + Steuerberater'],
      title: 'Freelancer'
    },
    freelancer_earlybird: {
      features: ['Alle Funktionen', '1 Nutzer + Steuerberater'],
      title: 'Einzelkämpfer'
    },
    monthly: 'mo',
    monthly_payment: 'Monatliche Zahlung',
    pricing_hint: 'Angegebene Preise sind Nettopreise und verstehen sich zzgl. der gesetzlichen MwSt.',
    student: {
      description: 'Für Studenten, die neben ihrem Studium freiberuflich arbeiten, bieten wir einen besonderen Tarif für nur <span class="text-bold">7 Euro pro Monat (netto)</span> an. ' +
        'Dieser Tarif entspricht dem "Freelancer" Tarif, jedoch mit <span class="text-bold">5 GB statt 100 GB</span> Speicherplatz und dir steht <span class="text-bold">kein Banking</span> zur Verfügung. ' +
        'Die einzige Voraussetzung ist, dass du die <span class="text-bold">Kleinunternehmerregelung nach § 19 UStG.</span> nutzt.',
      title: 'Studententarif'
    },
    website_hint: 'Für weitere Details bzgl. beinhalteter Funktionen, siehe unsere {website}.',
    yearly_payment: 'Jährliche Zahlung'
  },

  en: {
    business: {
      features: ['All Features', 'Unlimited Users'],
      title: 'Business'
    },
    business_earlybird: {
      features: ['Alle Funktionen', 'Unbegrenzt viele Nutzer'],
      title: 'Team Power'
    },
    freelancer: {
      features: ['All Features', '1 User + Tax Adviser'],
      title: 'Freelancer'
    },
    freelancer_earlybird: {
      features: ['Alle Funktionen', '1 Nutzer + Steuerberater'],
      title: 'Freelancer'
    },
    monthly: 'mo',
    monthly_payment: 'Monthly Payment',
    pricing_hint: 'All prices are net prices excluding the statutory VAT.',
    student: {
      description: 'We offer a special plan for students who work as a freelancer for just <span class="text-bold">7 Euro per month</span> (net). ' +
        'This plan is equivalent to the freelancer plan, except you only get <span class="text-bold">5 GB instead of 100 GB</span> and <span class="text-bold">can not use our banking features</span>. ' +
        'The only requirement is that you are a <span class="text-bold">small business by law</span> (§ 19 UStG.).',
      title: 'Student Plan'
    },
    website_hint: 'For further details about included features, see our {website}.',
    yearly_payment: 'Yearly Payment'
  }
}
